import nluApi from '../../api/nlu'
import uniqBy from 'lodash/uniqBy'

const cacheTime = 1000 * 30 // 30 seconds

export default {
  namespaced: true,

  state: {
    prebuiltModels: [],
    status: {
      fetching: false
    },
    lastFetchTime: null,
    lastModelLanguage: ''
  },

  mutations: {
    UPDATE_STATUS (state, updatedStatus) {
      state.status = {
        ...state.status,
        ...updatedStatus
      }
    },

    SET_PREBUILT_MODELS (state, prebuiltModels, language) {
      state.prebuiltModels = prebuiltModels
      state.lastFetchTime = new Date().getTime()
      state.lastModelLanguage = language
    }
  },

  actions: {
    async fetchPrebuiltModels ({ state, commit, rootState, rootGetters }, { language }) {
      if (state.status.fetching) { return }
      const timeElapsedAfterLastFetch = state.lastFetchTime && (new Date().getTime() - state.lastFetchTime)
      if (timeElapsedAfterLastFetch < cacheTime && state.lastModelLanguage === language) {
        console.log(`Not fetching prebuiltModels lastFetchTime < cacheTime for language: ${language}`)
        return
      }
      commit('UPDATE_STATUS', { fetching: true })
      try {
        let prebuiltModels = await nluApi.listAllPrebuiltModels({ lang: language })
        if (!Array.isArray(prebuiltModels)) {
          throw new Error(`Array was expected got: ${typeof prebuiltModels}`)
        }

        // HACK: to avoid fail on train, manually filter duplicated entites API return
        prebuiltModels = prebuiltModels.map(prebuilt => ({ ...prebuilt, entities: uniqBy(prebuilt.entities, 'name') }))

        commit('SET_PREBUILT_MODELS', prebuiltModels, language)
      } catch (error) {
        console.error("Wasn't able to fetch prebuilt models:", error)
        commit('SET_PREBUILT_MODELS', [], language)
      }
      commit('UPDATE_STATUS', { fetching: false })
    },

    async addPrebuiltModelToKM ({ state, commit, dispatch, rootState, rootGetters }, {
      prebuiltModelId,
      appId,
      appName,
      shouldCreateNewApplication,
      responses,
      entities
    }) {
      try {
        const current = rootGetters['knowledgebase/getCurrent']
        await nluApi.addPrebuiltModelToKM({
          kbId: current.id,
          prebuiltModelId,
          appId,
          appName,
          shouldCreateNewApplication,
          responses,
          entities
        })
        dispatch('knowledgebase/notifications/addInfo', {
          titleLabel: 'model.nlu-model.prebuilt-models.prebuilt-models.hasBeenImported'
        }, { root: true })
        await Promise.all([
          dispatch('knowledgebase/listAllModels', null, { root: true }),
          dispatch('knowledgebase/fetchCategories', null, { root: true }),
          dispatch('knowledgebase/entities/fetchAllEntities', null, { root: true })
        ])
      } catch (error) {
        console.error("Wasn't able to add prebuilt model to KM:", error)
      }
    },

    async removePrebuiltModeFromKM ({ state, commit, dispatch, rootState, rootGetters }, { prebuiltModelId }) {
      try {
        const current = rootGetters['knowledgebase/getCurrent']
        await nluApi.removePrebuiltModelFromKM({
          kbId: current.id,
          prebuiltModelId
        })

        await Promise.all([
          dispatch('knowledgebase/listAllModels', null, { root: true }),
          dispatch('knowledgebase/fetchAllApplications', null, { root: true }),
          dispatch('knowledgebase/fetchCategories', null, { root: true }),
          dispatch('knowledgebase/entities/fetchAllEntities', null, { root: true })
        ])
      } catch (e) {
        console.error("Wasn't able to remove prebuilt model from KM:", e)
      }
    },

    async getPrebuiltDetails ({ rootGetters, dispatch }, { prebuiltModelId }) {
      try {
        const current = rootGetters['knowledgebase/getCurrent']
        const response = await nluApi.getPrebuiltModelDetails({
          kbId: current.id,
          prebuiltModelId
        })
        await Promise.all([
          dispatch('knowledgebase/listAllModels', null, { root: true }),
          dispatch('knowledgebase/fetchAllApplications', null, { root: true }),
          dispatch('knowledgebase/fetchCategories', null, { root: true }),
          dispatch('knowledgebase/entities/fetchAllEntities', null, { root: true })
        ])

        return response
      } catch (error) {
        console.error("Wasn't able to get list of add prebuilt:", error)
      }
    }
  }
}
